/*=========================================================================================
  File Name: moduleChatActions.js
  Description: Chat Module Actions
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/

import axios from "@/axios.js"

export default {
    // Get chats from server. Also change in store
    fetchItems({ commit }) {
      return new Promise((resolve, reject) => {
        if (this.state.businessCategory.items.length)
          return;
        let payload = {
          params: {
            MaxResultCount: 9999,
          },
        };
        axios.get("/api/services/app/BusinessCategories/GetAll",payload)
          .then((response) => {
            commit('UPDATE_BusinessCategories', response.data)
            resolve(response)
          })
          .catch((error) => { reject(error) })
      })
    },
}
